"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M416.7,83.3H83.3c-23,0-41.7,18.7-41.7,41.7v250c0,23,18.7,41.7,41.7,41.7h333.3c23,0,41.7-18.7,41.7-41.7V125 C458.3,102,439.7,83.3,416.7,83.3z M333.3,125l-41.7,41.7H250l41.7-41.7H333.3z M270.8,300.8l-26,14.8l-15.2,8.8 c-5,2.9-11.4,1.2-14.2-3.8c-0.9-1.6-1.4-3.5-1.4-5.4v-47.1c-0.1-5.8,4.5-10.5,10.3-10.6c1.9,0,3.7,0.5,5.4,1.4l15.2,8.8l26,14.8 c5.1,3,6.8,9.5,3.8,14.5C273.7,298.6,272.4,299.9,270.8,300.8z M250,125l-41.7,41.7h-41.7l41.7-41.7H250z M125,125h41.7L125,166.7 H83.3L125,125z M375,166.7h-41.7L375,125h41.7L375,166.7z"
  }));
};

exports.default = _default;